import React, { useLayoutEffect } from 'react';
import {
  PageContainer,
  ContentContainer,
  Content,
  Title,
  Text,
  StyledList,
  StyledLi,
  StyledSubtitle,
  DateSubtitle,
} from './Hikes.styles';
import { PhotoGallery } from './PhotoGallery';
import { imagesSlowacja2026 } from './images';

export const Slowacja2026: React.FC = () => {
  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <PageContainer>
      <ContentContainer>
        <Content>
          <Title>Tatry Wysokie</Title>
          <DateSubtitle>28-31.05.2026 | 6 miejsc</DateSubtitle>
          <Text>
            Intensywny długi weekend w Tatrach Wysokich. Trasy dla osób z dobrą kondycją; w planie
            m.in. Skalnaté Pleso i Sławkowski Szczyt.
          </Text>

          <StyledSubtitle>
            Dzień 1: Skalnaté Pleso i pierwszy kontakt z Tatrami Słowackimi
          </StyledSubtitle>
          <Text>
            Wyjazd zaczęliśmy od mocnego, tatrzańskiego akcentu. Tatrzańska Łomnica przywitała nas
            górskim klimatem, a im bliżej byliśmy Skalnatégo Plesa, tym bardziej krajobraz robił się
            surowy i wysokogórski. Skały, chłodne powietrze, staw położony pod potężnymi ścianami i
            widok na Łomnicę stworzyły idealne otwarcie całej wyprawy. To był dzień, w którym od
            razu poczuliśmy, że jesteśmy w górach naprawdę, nie tylko “na spacerze”.
          </Text>

          <StyledSubtitle>Dzień 2: Pieniny, Trzy Korony i szarlotka z widokiem</StyledSubtitle>
          <Text>
            Drugiego dnia tempo zwolniło, ale klimat wcale nie był słabszy. Przenieśliśmy się w
            Pieniny, gdzie zamiast surowych tatrzańskich ścian pojawiły się łagodniejsze krajobrazy,
            Dunajec i widok na Trzy Korony. Deszczowa pogoda nie zepsuła dnia, tylko nadała mu
            bardziej spokojny, trochę filmowy charakter. Najlepszym momentem była szarlotka jedzona
            z widokiem na Trzy Korony — dokładnie taki prosty punkt programu, który później pamięta
            się najlepiej. Wieczorem dzień domknęła kolacja w słowackiej knajpie: dobre jedzenie,
            odpoczynek i poczucie, że nawet bez wielkiej trasy można mieć bardzo udany dzień.
          </Text>

          <StyledSubtitle>Dzień 3: Nosal, Ekochatka i ostatnie spojrzenie na Tatry</StyledSubtitle>
          <Text>
            Na koniec został Nosal — krótki, konkretny i idealny przed drogą do domu. To nie była
            długa wyprawa, ale miała wszystko, czego potrzeba na pożegnanie z górami: podejście,
            trochę wysiłku, widok ze szczytu i ten moment, kiedy człowiek jeszcze na chwilę
            zatrzymuje się, żeby spojrzeć na Tatry przed powrotem do codzienności. Po zejściu nie
            ruszyłyśmy od razu w drogę — najpierw był jeszcze spokojny przystanek w Ekochatce na
            kawę i ciasto. To był idealny miękki finał wyjazdu: już po trasie, jeszcze w górskim
            klimacie, bez pośpiechu. Dopiero potem wsiadłyśmy do auta i ruszyłyśmy do domu z głową
            pełną widoków.
          </Text>

          <Text>
            Cały wyjazd miał bardzo dobry rytm: najpierw wysokogórskie Tatry Słowackie, potem
            spokojniejsze Pieniny z widokami, szarlotką i kolacją, a na końcu krótki Nosal, kawa i
            ciasto jako symboliczne pożegnanie z górami. Nie był to wyjazd gonienia kilometrów za
            wszelką cenę, tylko dobrze ułożona historia: trochę wysiłku, trochę odpoczynku, trochę
            deszczu i dużo dobrych wspomnień.
          </Text>

          <Text style={{ marginBottom: '5px' }}>
            <strong>W cenie:</strong>
          </Text>
          <StyledList>
            <StyledLi>3 noclegi</StyledLi>
            <StyledLi>transport z Polski i lokalny dojazd na szlaki (paliwo i opłaty)</StyledLi>
            <StyledLi>2 dni trekkingowe</StyledLi>
            <StyledLi>elastyczny plan dnia</StyledLi>
            <StyledLi>opieka i organizacja</StyledLi>
            <StyledLi>ubezpieczenie turystyczne</StyledLi>
          </StyledList>

          <Text style={{ marginBottom: '5px' }}>
            <strong>Dodatkowo płatne:</strong>
          </Text>
          <StyledList>
            <StyledLi>wyżywienie</StyledLi>
            <StyledLi>atrakcje dodatkowe (np. aquapark, saunarium)</StyledLi>
          </StyledList>

          <PhotoGallery images={imagesSlowacja2026} wide />
        </Content>
      </ContentContainer>
    </PageContainer>
  );
};

export default Slowacja2026;
